import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-ink-200 bg-white mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center gap-4">
              <img
                src="https://customer-assets.emergentagent.com/job_restore-sleep/artifacts/ote6ytks_Screenshot%202026-05-03%20at%202.56.54%E2%80%AFAM.png"
                alt="Restore.JC"
                className="h-20 w-20 rounded-full object-cover"
              />
              <span className="font-display text-3xl tracking-tight text-ink-900 font-light">
                restore<span className="text-brand-600">.</span>
                <span className="font-medium">jc</span>
              </span>
            </Link>
            <p className="mt-5 text-ink-600 max-w-md leading-relaxed">
              Sleep optimization coaching for high-performing professionals.
              Restore deep sleep. Rebuild energy. Reclaim your edge.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-xs uppercase tracking-[0.2em] text-ink-500 mb-5">
              Navigate
            </h4>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/services", label: "Services" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-ink-700 hover:text-brand-600 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display text-xs uppercase tracking-[0.2em] text-ink-500 mb-5">
              Contact
            </h4>
            <ul className="space-y-4 text-ink-700">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 text-brand-600" />
                <span>
                  Vancouver, BC <span className="text-ink-400">/</span> Los Angeles
                </span>
              </li>
              <li>
                <a
                  href="tel:+17782397162"
                  data-testid="footer-phone"
                  className="flex items-center gap-3 hover:text-brand-600 transition-colors"
                >
                  <Phone size={16} className="text-brand-600" />
                  778-239-7162
                </a>
              </li>
              <li>
                <a
                  href="mailto:xycjustin@gmail.com"
                  data-testid="footer-email"
                  className="flex items-center gap-3 hover:text-brand-600 transition-colors"
                >
                  <Mail size={16} className="text-brand-600" />
                  xycjustin@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-ink-200 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-ink-500 text-sm">
            © {new Date().getFullYear()} Restore.JC — Justin Chen. All rights reserved.
          </p>
          <p className="text-ink-500 text-sm">
            Website managed by{" "}
            <a
              href="https://www.verifieddigital.solutions/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-vds-link"
              className="text-ink-700 hover:text-brand-600 transition-colors underline-offset-4 hover:underline"
            >
              Verified Digital Solutions
            </a>
          </p>
          <p className="text-ink-400 text-xs tracking-widest uppercase">
            Sleep · Energy · Performance
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
